import React, { useContext, createContext, useState } from 'react';
import { Api } from './../../app-controller.js';
import env from './../../environment.js';
import ROLES from '../../constants/Roles.js';
import { getJSON, setJSON } from '../../utils/localStorageJSON.js';

/** For more details on
 * `authContext`, `ProvideAuth`, `useAuth` and `useProvideAuth`
 * refer to: https://usehooks.com/useAuth/
 */

const authContext = createContext();

/**
 * ProvideAuth wraps all our authentication methods
 */
export function ProvideAuth({ children }) {
  const [user, setUser] = useState(() => {
    return getJSON(`${env.appName}-user`);
  });

  const login = state => {
    //call to function login in API
    return Api.fetch('auth/login', state, 'POST').then(response => {
      //setting user and saving token and user to mantain session
      let usuario = { ...response.user, permissions: response.permissions };
      setUser(usuario);
      localStorage.setItem(`${env.appName}-token`, response.token);
      setJSON(`${env.appName}-user`, usuario);
      setJSON(`${env.appName}-sesion`, usuario);
      setJSON(`${env.appName}-coop-config`, response.coopconfig);
      localStorage.setItem(`sidebar`, 'true');
      Api.user_profile = usuario;
      return usuario;
    });
  };

  const logout = () => {
    localStorage.clear(`${env.appName}-token`);
    localStorage.clear(`${env.appName}-user`);
    localStorage.clear(`${env.appName}-sesion`);
    localStorage.clear(`${env.appName}-coop-config`);
    localStorage.clear('dashboard');
    window.location.href = '/user/login-v3';
  };

  const profile = () => {
    return Api.fetch('auth/profile', null, 'POST').then(data => {
      return data;
    });
  };

  const checkUser = () => {
    return getJSON(`${env.appName}-user`);
  };

  const isAdmin = () => {
    return user.id_rol === ROLES.ADMIN;
  };

  const getCertification = () => {
    if (user !== null && user.certificacion && user.certificacion !== '') {
      return user.certificacion;
    } else {
      return 'certimex';
    }
  };

  const hasAccess = permission => {
    if (typeof permission !== 'undefined' && user !== null && user.permissions.length) {
      let found = user.permissions.filter(x => x.includes(permission)).length !== 0;
      return found;
    } else {
      return true;
    }
  };

  const hasPermission = permission_action => {
    if (typeof permission_action !== 'undefined' && user != null && user.permissions.length) {
      let found = user.permissions.filter(x => x === permission_action).length !== 0;
      return found;
    } else {
      return true;
    }
  };

  const auth = { user, login, logout, profile, checkUser, isAdmin, getCertification, hasAccess, hasPermission };

  return <authContext.Provider value={auth}>{children}</authContext.Provider>;
}

/**
 * useAuth hook enables any component to get the current auth state and re-render if it changes.
 **/

export function useAuth() {
  return useContext(authContext);
}
